import React, { useState, useEffect } from "react";
import { db } from "../firebaseConfig";
import {
  collection,
  addDoc,
  getDocs,
  deleteDoc,
  doc,
  updateDoc,
} from "firebase/firestore";
import {
  Container,
  Typography,
  TextField,
  Button,
  Box,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Snackbar,
  Alert,
  Tabs,
  Tab,
  Paper,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useTheme, useMediaQuery,
  Card,
  CardContent,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@mui/material";
import { Edit, Delete } from "@mui/icons-material";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import CloseIcon from "@mui/icons-material/Close";

const RegistroUnidadTipoUnidad = () => {
  const [tab, setTab] = useState(0);
  const isMobile = useMediaQuery(useTheme().breakpoints.down("sm"));

  // Estado general
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false); // Estado para abrir/ cerrar el modal de eliminación
  const [alertMessage, setAlertMessage] = useState(""); // Mensaje de alerta
  const [alertOpen, setAlertOpen] = useState(false); // Estado para abrir/ cerrar la alerta
  const [alertSeverity, setAlertSeverity] = useState("success"); // Severidad de la alerta (success, error)

  // Estado de eliminación
  const [currentDeleteId, setCurrentDeleteId] = useState(null);
  const [currentDeleteCollection, setCurrentDeleteCollection] = useState("");
  const [currentDeleteLabel, setCurrentDeleteLabel] = useState("");


  // Tipo unidades
  const [tipoUnidadList, settipoUnidadList] = useState([]);
  const [formDatatipoUnidad, setFormDatatipoUnidad] = useState({ nombre: "", descripcion: "", abreviatura: "" });
  const [showFormTipo, setShowFormTipo] = useState(false);
  const [editingTipoId, setEditingTipoId] = useState(null);

  // unidades
  const [formDataUnidad, setFormDataUnidad] = useState({ nombre: "", descripcion: "", id_tipoUnidad: "", precio: "" });
  const [unidadesList, setunidadesList] = useState([]);
  const [showFormUnidad, setShowFormUnidad] = useState(false);
  const [editingUnidadId, setEditingUnidadId] = useState(null);
  const [empresas, setEmpresas] = useState([]);

  useEffect(() => {
    getAllData();
  }, []);

  const getAllData = async () => {
    const tiposSnapshot = await getDocs(collection(db, "tipoUnidad"));
    settipoUnidadList(tiposSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));

    const unidadesSnapshot = await getDocs(collection(db, "unidades"));
    setunidadesList(unidadesSnapshot.docs.map(doc => ({ id: doc.id, ...doc.data() })));

    // Obtener empresas
    const empresasCollection = collection(db, "empresas");
    const empresasSnapshot = await getDocs(empresasCollection);
    if (!empresasSnapshot.empty) {
      setEmpresas(empresasSnapshot.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
    } else {
      console.log("No hay empresas disponibles.");
    }
  };

  // const handleAlert = (message, severity) => {
  //   setAlertInfo({ message, severity });
  //   setOpenAlert(true);
  // };

  const handleAlert = (message, severity) => {
    setAlertMessage(message);
    setAlertSeverity(severity);
    setAlertOpen(true);
  };

  const handleSubmitTipo = async (e) => {
    e.preventDefault();
    try {
      if (editingTipoId) {
        // Actualizar tipo de Unidad
        await updateDoc(doc(db, "tipoUnidad", editingTipoId), formDatatipoUnidad);
        setAlertMessage("Tipo de Unidad actualizado exitosamente.");
        setAlertSeverity("success");
      } else {
        // Agregar nuevo tipo de Unidad
        await addDoc(collection(db, "tipoUnidad"), formDatatipoUnidad);
        setAlertMessage("Nuevo tipo de Unidad agregado exitosamente.");
        setAlertSeverity("success");
      }

      setFormDatatipoUnidad({ nombre: "", descripcion: "", abreviatura: "" });
      setEditingTipoId(null);
      setShowFormTipo(false);
      setAlertOpen(true); // Mostrar alerta
      getAllData();
    } catch (error) {
      console.error("Error al guardar tipo de Unidad:", error);
      setAlertMessage("Ocurrió un error. Intenta nuevamente.");
      setAlertSeverity("error");
      setAlertOpen(true); // Mostrar alerta
    }
  };


  const handleSubmitUnidad = async (e) => {
    e.preventDefault();
    try {
      if (editingUnidadId) {
        // Actualizar Unidad
        await updateDoc(doc(db, "unidades", editingUnidadId), formDataUnidad);
        setAlertMessage("Unidad actualizado exitosamente.");
        setAlertSeverity("success");
      } else {
        // Agregar nuevo Unidad
        await addDoc(collection(db, "unidades"), formDataUnidad);
        setAlertMessage("Nuevo Unidad agregado exitosamente.");
        setAlertSeverity("success");
      }

      setFormDataUnidad({ nombre: "", descripcion: "", id_tipoUnidad: "", precio: "" });
      setEditingUnidadId(null);
      setShowFormUnidad(false);
      setAlertOpen(true); // Mostrar alerta
      getAllData();
    } catch (error) {
      console.error("Error al guardar Unidad:", error);
      setAlertMessage("Ocurrió un error. Intenta nuevamente.");
      setAlertSeverity("error");
      setAlertOpen(true); // Mostrar alerta
    }
  };

  const handleDelete = async (id, collectionName) => {
    await deleteDoc(doc(db, collectionName, id));
    getAllData();
    handleAlert("Eliminado correctamente", "success");
  };

  const handleOpenDeleteDialog = (id, collectionName, label) => {
    setCurrentDeleteId(id);
    setCurrentDeleteCollection(collectionName);
    setCurrentDeleteLabel(label);
    setOpenDeleteDialog(true);
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
    setCurrentDeleteId(null);
    setCurrentDeleteCollection("");
    setCurrentDeleteLabel("");
  };

  const handleConfirmDelete = async () => {
    if (currentDeleteId && currentDeleteCollection) {
      await handleDelete(currentDeleteId, currentDeleteCollection);
      handleCloseDeleteDialog();
    }
  };


  return (
    <Container maxWidth="lg" sx={{ py: 4 }}>
      <Typography variant="h5" sx={{ fontWeight: "bold", color: "#1A3E5D", marginBottom: 2 }}>
        Gestión de Tipos de Unidad y unidades
      </Typography>

      <Tabs value={tab} onChange={(e, newVal) => setTab(newVal)} sx={{ mb: 3 }}>
        <Tab label="Tipos de Unidad" />
        <Tab label="unidades" />
      </Tabs>

      {tab === 0 && (
        showFormTipo ? (
          <Box>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 2 }}>
              <Typography variant="h5" sx={{ fontWeight: "bold", color: "#1A3E5D" }}>
                {editingTipoId ? "Editar Tipo de Unidad" : "Nuevo Tipo de Unidad"}
              </Typography>
              <IconButton onClick={() => setShowFormTipo(false)} color="#01579b">
                <CloseIcon />
              </IconButton>
            </Box>

            <form onSubmit={handleSubmitTipo}>
              <TextField
                fullWidth label="Nombre" margin="normal"
                value={formDatatipoUnidad.nombre}
                onChange={(e) => setFormDatatipoUnidad({ ...formDatatipoUnidad, nombre: e.target.value })}
              />
              <TextField
                fullWidth label="Descripción" margin="normal"
                value={formDatatipoUnidad.descripcion}
                onChange={(e) => setFormDatatipoUnidad({ ...formDatatipoUnidad, descripcion: e.target.value })}
              />
              <TextField
                fullWidth label="Abreviatura" margin="normal"
                value={formDatatipoUnidad.abreviatura}
                onChange={(e) => setFormDatatipoUnidad({ ...formDatatipoUnidad, abreviatura: e.target.value })}
              />

              <Box sx={{ marginTop: 2 }}>
                <Button type="submit" variant="contained" fullWidth sx={{ backgroundColor: "#01579b", color: "white", '&:hover': { backgroundColor: "#014377" } }}>
                  {editingTipoId ? "Actualizar Tipo de Unidad" : "Guardar Tipo de Unidad"}
                </Button>
              </Box>
            </form>
          </Box>
        ) : (
          <>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddCircleIcon />}
              onClick={() => setShowFormTipo(true)}
              sx={{ marginBottom: 2 }}
            >
              Agregar Tipo de Unidad
            </Button>
            {isMobile ? (
              <Box>
                {tipoUnidadList.map((tipo) => (
                  <Card key={tipo.id} sx={{ marginBottom: 2, padding: 2 }}>
                    <CardContent>
                      <Typography><strong>Nombre:</strong> {tipo.nombre}</Typography>
                      <Typography><strong>Descripción:</strong> {tipo.descripcion}</Typography>
                      <Typography><strong>Abreviatura:</strong> {tipo.abreviatura}</Typography>
                      <Box mt={1}>
                        <IconButton color="primary" onClick={() => {
                          setFormDatatipoUnidad(tipo);
                          setEditingTipoId(tipo.id);
                          setShowFormTipo(true);
                        }}>
                          <Edit />
                        </IconButton>
                        <IconButton color="secondary" onClick={() => handleDelete(tipo.id, "tipoUnidad")}>
                          <Delete />
                        </IconButton>
                      </Box>
                    </CardContent>
                  </Card>
                ))}
              </Box>
            ) : (
              <TableContainer component={Paper} sx={{ marginTop: 2 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Nombre</TableCell>
                      <TableCell>Descripción</TableCell>
                      <TableCell>Abreviatura</TableCell>
                      <TableCell>Acciones</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {tipoUnidadList.map((tipo) => (
                      <TableRow key={tipo.id}>
                        <TableCell>{tipo.nombre}</TableCell>
                        <TableCell>{tipo.descripcion}</TableCell>
                        <TableCell>{tipo.abreviatura}</TableCell>
                        <TableCell>
                          <IconButton color="primary" onClick={() => {
                            setFormDatatipoUnidad(tipo);
                            setEditingTipoId(tipo.id);
                            setShowFormTipo(true);
                          }}>
                            <Edit />
                          </IconButton>
                          <IconButton color="secondary" onClick={() => handleOpenDeleteDialog(tipo.id, "tipoUnidad", "Tipo de Unidad")}>
                            <Delete />
                          </IconButton>

                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </>
        )
      )}

      {tab === 1 && (
        showFormUnidad ? (
          <Box>
            <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 2 }}>
              <Typography variant="h5" sx={{ fontWeight: "bold", color: "#1A3E5D" }}>
                {editingUnidadId ? "Editar Unidad" : "Nuevo Unidad"}
              </Typography>
              <IconButton onClick={() => setShowFormUnidad(false)} color="#01579b">
                <CloseIcon />
              </IconButton>
            </Box>

            <form onSubmit={handleSubmitUnidad}>
              <FormControl fullWidth margin="normal">
                <InputLabel>Tipo de Unidad</InputLabel>
                <Select
                  value={formDataUnidad.id_tipoUnidad}
                  onChange={(e) => setFormDataUnidad({ ...formDataUnidad, id_tipoUnidad: e.target.value })}
                >
                  {tipoUnidadList.map((tipo) => (
                    <MenuItem key={tipo.id} value={tipo.id}>
                      {tipo.nombre}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
              <TextField
                fullWidth label="Numero" margin="normal"
                value={formDataUnidad.numero}
                onChange={(e) => setFormDataUnidad({ ...formDataUnidad, numero: e.target.value })}
              />
              <TextField
                fullWidth label="Placa" margin="normal"
                value={formDataUnidad.placa}
                onChange={(e) => setFormDataUnidad({ ...formDataUnidad, placa: e.target.value })}
              />
              <TextField
                fullWidth label="Marca" margin="normal" type="normal"
                value={formDataUnidad.marca}
                onChange={(e) => setFormDataUnidad({ ...formDataUnidad, marca: e.target.value })}
              />
              <TextField
                fullWidth label="Año" margin="normal" type="number"
                value={formDataUnidad.año}
                onChange={(e) => setFormDataUnidad({ ...formDataUnidad, año: e.target.value })}
              />
              <FormControl fullWidth margin="normal">
                <InputLabel>Empresa</InputLabel>
                <Select
                  value={formDataUnidad.id_empresa}
                  onChange={(e) => setFormDataUnidad({ ...formDataUnidad, id_empresa: e.target.value })}
                >
                  {empresas.map((empresa) => (
                    <MenuItem key={empresa.id} value={empresa.id}>{empresa.nombre}</MenuItem>
                  ))}
                </Select>
              </FormControl>

              <Box sx={{ marginTop: 2 }}>
                <Button type="submit" variant="contained" fullWidth sx={{ backgroundColor: "#01579b", color: "white", '&:hover': { backgroundColor: "#014377" } }}>
                  {editingUnidadId ? "Actualizar Unidad" : "Guardar Unidad"}
                </Button>
              </Box>
            </form>
          </Box>
        ) : (
          <>
            <Button
              variant="contained"
              color="primary"
              startIcon={<AddCircleIcon />}
              onClick={() => setShowFormUnidad(true)}
              sx={{ marginBottom: 2 }}
            >
              Agregar Unidad
            </Button>
            {isMobile ? (
              <Box>
                {unidadesList.map((unidad) => (
                  <Card key={unidad.id} sx={{ marginBottom: 2, padding: 2 }}>
                    <CardContent>
                      <Typography><strong>Tipo de Unidad:</strong> {tipoUnidadList.find((tipo) => tipo.id === unidad.id_tipoUnidad)?.nombre || 'Sin tipo'}</Typography>
                      <Typography><strong>Número:</strong> {unidad.numero}</Typography>
                      <Typography><strong>Placa:</strong> {unidad.placa}</Typography>
                      <Typography><strong>Marca:</strong> {unidad.marca}</Typography>
                      <Typography><strong>Año:</strong> {unidad.año}</Typography>
                      <Typography><strong>Empresa:</strong> {empresas.find((empresa) => empresa.id === unidad.id_empresa)?.nombre || 'Sin empresa'}</Typography>
                      <Box mt={1}>
                        <IconButton color="primary" onClick={() => {
                          setFormDataUnidad(unidad);
                          setEditingUnidadId(unidad.id);
                          setShowFormUnidad(true);
                        }}>
                          <Edit />
                        </IconButton>
                        <IconButton color="secondary" onClick={() => handleDelete(unidad.id, "unidades")}>
                          <Delete />
                        </IconButton>
                      </Box>
                    </CardContent>
                  </Card>
                ))}
              </Box>
            ) : (
              <TableContainer component={Paper} sx={{ marginTop: 2 }}>
                <Table>
                  <TableHead>
                    <TableRow>
                      <TableCell>Tipo de Unidad</TableCell>
                      <TableCell>Número</TableCell>
                      <TableCell>Placa</TableCell>
                      <TableCell>Marca</TableCell>
                      <TableCell>Año</TableCell>
                      <TableCell>Empresa</TableCell>
                      <TableCell>Acciones</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {unidadesList.map((unidad) => (
                      <TableRow key={unidad.id}>
                        <TableCell>
                          {tipoUnidadList.find((tipo) => tipo.id === unidad.id_tipoUnidad)?.nombre || 'Sin tipo'}
                        </TableCell>
                        <TableCell>{unidad.numero}</TableCell>
                        <TableCell>{unidad.placa}</TableCell>
                        <TableCell>{unidad.marca}</TableCell>
                        <TableCell>{unidad.año}</TableCell>
                        <TableCell>{empresas.find((empresa) => empresa.id === unidad.id_empresa)?.nombre || 'Sin empresa'}</TableCell>

                        <TableCell>
                          <IconButton color="primary" onClick={() => {
                            setFormDataUnidad(unidad);
                            setEditingUnidadId(unidad.id);
                            setShowFormUnidad(true);
                          }}>
                            <Edit />
                          </IconButton>
                          <IconButton color="secondary" onClick={() => handleOpenDeleteDialog(unidad.id, "unidades", "Unidad")}>
                            <Delete />
                          </IconButton>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            )}
          </>
        )
      )}

      {/* Alerta */}
      <Snackbar open={alertOpen} autoHideDuration={6000} onClose={() => setAlertOpen(false)} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <Alert onClose={() => setAlertOpen(false)} severity={alertSeverity} sx={{ width: "100%" }}>
          {alertMessage}
        </Alert>
      </Snackbar>

      {/* Modal de Confirmación de Eliminación */}
      <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
        <DialogTitle>Confirmación</DialogTitle>
        <DialogContent>
          <Typography>¿Estás seguro de eliminar este {currentDeleteLabel.toLowerCase()}?</Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog} color="primary">
            Cancelar
          </Button>
          <Button onClick={handleConfirmDelete} color="secondary">
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default RegistroUnidadTipoUnidad;
